import cn from 'classnames';
import { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Logo } from '@features/common';
import { Close } from '@shared/assets';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { IconButton } from '@shared/ui';
import { ModalMiddle } from '@src/library/components/common';
import { Spinner } from 'library/components/shop';
import { usePromocode } from 'library/hooks/shop';
import * as st from './styles.module.scss';

export const PromoModal = () => {
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();
  const { code, status } = usePromocode();
  const params = useParams<{ tab: string; code: string }>();
  const { module } = useModuleByCodeParam();

  const onClose = () => {
    navigate(`/shop/${params.code}/${params.tab}`);
  };

  const onCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <ModalMiddle isOpen>
      {status === 'loading' && (
        <div className={st.loader}>
          <Spinner />
        </div>
      )}
      {status === 'loaded' && (
        <>
          <div className={st.promoModal__header}>
            <Link className={st.logo} to="/">
              <Logo />
            </Link>
            <p>Поделитесь промокодом с Вашим клиентом</p>
            <IconButton variant="dark" onClick={onClose}>
              <Close />
            </IconButton>
          </div>

          <div className={st.promoModal__body}>
            <section className={st.promoModal__data}>
              <div className={st.promoModal__title}>Сообщение</div>
              <div className={st.promoModal__wrapper}>
                <p>
                  При покупке товара в магазине
                  <a
                    href={`${window.location.origin}/shop/${module?.code}`}
                  >{` ${window.location.origin}/shop/${module?.code}`}</a>
                </p>

                <p>Вы можете воспользоваться моей персональной скидкой 👇</p>
                <p>
                  При оформлении товара введите промокод: <span>{code}</span>
                </p>
              </div>
            </section>

            <section className={st.promoModal__submit}>
              <CopyToClipboard
                text={`При покупке товара в магазине ${window.location.origin}/shop/${module?.code} \n Вы можете воспользоваться моей персональной скидкой 👇 \n При оформлении товара введите промокод: ${code}`}
                onCopy={onCopy}
              >
                <button className={st.promoModal__body__copy}>Скопировать</button>
              </CopyToClipboard>
            </section>
          </div>

          <div className={cn(st.message, copied && st.visible)}>Скопировано в буфер обмена</div>
        </>
      )}
    </ModalMiddle>
  );
};
